export default __webpack_public_path__ + "static/media/Home-foto-header-incoming-Tower-viajes-mobile@3x.32c44e9c.jpg";